import { render, staticRenderFns } from "./BasicPieGraph.vue?vue&type=template&id=2e7cfe48"
import script from "./BasicPieGraph.vue?vue&type=script&lang=js"
export * from "./BasicPieGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports